
export enum SceneIds {
  Welcome = 'Welcome',
  Tutorial = 'Tutorial',
  Game = 'Game',
  GameOver = 'GameOver',
};
